export default {
  OPPORTUNITY_LIST: "OPPORTUNITY_LIST",
  LOW_PERFORMANCE_KEYWORDS: "LOW_PERFORMANCE_KEYWORDS",
};
